import React from 'react'

const Search = ({ size, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
    fill={color}
    role="img"
  >
    <title>Search</title>
    <path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z" />
  </svg>
)
const AuthLogo = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="8 8 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Bank 1 logo"
  >
    <title>Bank 1 logo</title>
    <path
      d="M24.5 16.3333C21.4058 16.3333 18.4384 17.5625 16.2505 19.7504C14.0625 21.9383 12.8334 24.9058 12.8334 28C12.8334 31.0942 14.0625 34.0616 16.2505 36.2496C18.4384 38.4375 21.4058 39.6667 24.5 39.6667C27.5942 39.6667 30.5617 38.4375 32.7496 36.2496C34.9375 34.0616 36.1667 31.0942 36.1667 28C36.1667 24.9058 34.9375 21.9383 32.7496 19.7504C30.5617 17.5625 27.5942 16.3333 24.5 16.3333Z"
      fill="#FFC107"
    />
    <path
      d="M38.5001 39.6667C38.2668 39.6667 38.0335 39.55 37.8001 39.4333C37.3335 39.0833 37.2168 38.2667 37.5668 37.8C39.6668 34.8833 40.8335 31.5 40.8335 28C40.8335 24.5 39.6668 21.1167 37.5668 18.2C37.2168 17.7333 37.3335 16.9167 37.8001 16.5667C38.2668 16.2167 39.0835 16.3333 39.4335 16.8C41.8835 20.0667 43.1668 23.9167 43.1668 28C43.1668 32.0833 41.8835 35.9333 39.4335 39.2C39.2001 39.55 38.8501 39.6667 38.5001 39.6667Z"
      fill="#0F62FE"
    />
  </svg>
)

const PreConsentLogo = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Compare Banks logo"
  >
    <title>Compare Banks logo</title>
    <path
      d="M14.7496 26.7502C10.1934 26.7502 6.49963 23.0565 6.49963 18.5002C6.49963 13.944 10.1934 6.50024 14.7496 6.50024C19.3059 6.50024 22.9996 13.944 22.9996 18.5002C22.9996 23.0565 19.3059 26.7502 14.7496 26.7502Z"
      fill="#FF4080"
    />
    <path
      d="M13.2496 25.2502C13.2496 20.694 16.9434 17.0002 21.4996 17.0002C26.0559 17.0002 33.4996 20.694 33.4996 25.2502C33.4996 29.8065 26.0559 33.5002 21.4996 33.5002C16.9434 33.5002 13.2496 29.8065 13.2496 25.2502Z"
      fill="#6236FF"
    />
  </svg>
)

const NavMenu = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <rect opacity="0.01" width="16" height="16" fill="#313131" />
    <rect y="12" width="16" height="2" fill="#00698F" />
    <rect y="7" width="16" height="2" fill="#00698F" />
    <rect y="2" width="16" height="2" fill="#00698F" />
  </svg>
)

export { Search, AuthLogo, PreConsentLogo, NavMenu }
